import { render, staticRenderFns } from "./HistoricSessionInfo.vue?vue&type=template&id=35e9316e&scoped=true&"
import script from "./HistoricSessionInfo.vue?vue&type=script&lang=js&"
export * from "./HistoricSessionInfo.vue?vue&type=script&lang=js&"
import style0 from "./HistoricSessionInfo.vue?vue&type=style&index=0&id=35e9316e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9316e",
  null
  
)

export default component.exports